import Swiper, { EffectFade, Lazy, Navigation, Pagination } from "swiper";

class GallerySimple {
  wrapper = null;

  constructor(el) {
    this.wrapper = $(el);

    if (this.wrapper.length) {
      this.init();
    }
  }

  init() {
    new Swiper(this.wrapper.children(".swiper")[0], {
      modules: [EffectFade, Lazy, Navigation, Pagination],
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: this.wrapper.find(".swiper-pagination")[0],
        type: "fraction",
      },

      navigation: {
        nextEl: this.wrapper.find(".swiper-nav--next")[0],
        prevEl: this.wrapper.find(".swiper-nav--prev")[0],
      },
    });
  }
}

export default GallerySimple;
